export const Page404Template = `
  <p class="error-page__error-text">404</p>
  <p class="error-page__error-text">Page not found</p>
  {{{backLink}}}
`;
